<div [formGroup]="formGroup">
  <div>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>{{ minimum }}</mat-label>
      <input matInput min="0" type="number" formControlName="minNumber" (change)="fireRangeChangedEvent()" />
      <mat-error *ngIf="formGroup.hasError('rangeError')"></mat-error>
      <mat-error *ngIf="minNumberControl().hasError('numberRange')"></mat-error>
    </mat-form-field>
    <mat-error *ngIf="formGroup.hasError('rangeError')">Minimum value must be less than the maximum value.</mat-error>
    <mat-error *ngIf="minNumberControl().hasError('numberRange')">{{
      minNumberControl().getError('numberRange')
    }}</mat-error>
  </div>
  <div>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>{{ maximum }}</mat-label>
      <input matInput min="0" type="number" formControlName="maxNumber" (change)="fireRangeChangedEvent()" />
      <mat-error *ngIf="formGroup.hasError('rangeError')"></mat-error>
      <mat-error *ngIf="maxNumberControl().hasError('numberRange')"></mat-error>
    </mat-form-field>
    <mat-error *ngIf="formGroup.hasError('rangeError')">Maximum value must be larger than the minimum value.</mat-error>
    <mat-error *ngIf="maxNumberControl().hasError('numberRange')">{{
      maxNumberControl().getError('numberRange')
    }}</mat-error>
  </div>
</div>
